import { render } from "./Printers.vue?vue&type=template&id=07e868f4"
import script from "./Printers.vue?vue&type=script&lang=js"
export * from "./Printers.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__